import React from "react"
import { Link, withRouter } from "react-router-dom"
import iconWallet from '../../assets/icons/wallet.svg'
import iconTransaction from '../../assets/icons/transaction.svg'
import iconObligation from '../../assets/icons/obligation.svg'

const PaymentMenu = () => {
    return (
        <div className="menu">
            <Link className="item" to="/payment/obligations"><img src={iconObligation} alt="" /><span>Obligations</span></Link>
            <Link className="item" to="/payment/transactions"><img src={iconTransaction} alt="" /><span>Transactions</span></Link>
            <Link className="item" to="/payment/wallet"><img src={iconWallet} alt="" /><span>Wallet</span></Link>
        </div>
    )
}

export default withRouter(PaymentMenu)